/**
 * Query-param plumbing for narrowing a read to the caller's own consigned
 * vehicles.
 *
 * Kept beside the region scope it works with, and apart from any one
 * module's `api.ts`, because two unrelated modules append it: the vehicles
 * list and every report. The server resolves "whose" from the authenticated
 * caller — the client never names an owner, so there is nothing here to get
 * wrong but the presence of the flag.
 */

/** The key a consigned-scoped request uses. */
export const CONSIGNED_ONLY_PARAM = "consigned_only";

/**
 * Narrow a set of query params to the caller's consigned vehicles.
 *
 * Absent and `false` emit NOTHING rather than `consigned_only=false`: the
 * request has to come out identical to one built by a caller that has never
 * heard of consigned reach, which is every caller before this change.
 *
 * @returns the same `searchParams`, for chaining
 */
export function appendConsignedOnly(
  searchParams: URLSearchParams,
  consignedOnly?: boolean | null,
): URLSearchParams {
  if (consignedOnly) {
    searchParams.append(CONSIGNED_ONLY_PARAM, "true");
  }

  return searchParams;
}
